var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C11.706 12 13.5 10.206 13.5 8C13.5 5.794 11.706 4 9.5 4C7.294 4 5.5 5.794 5.5 8C5.5 10.206 7.294 12 9.5 12ZM11 13H8C4.691 13 2 15.691 2 19V20H17V19C17 15.691 14.309 13 11 13Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6046 11.048C17.2136 10.0101 17.4766 8.80528 17.3556 7.60797C17.1766 5.82397 16.1806 4.24697 14.5526 3.16797L13.4476 4.83397C14.5666 5.57597 15.2476 6.63297 15.3656 7.80797C15.42 8.35407 15.352 8.90543 15.1666 9.42195C14.9811 9.93847 14.6829 10.4072 14.2936 10.794L13.1016 11.986L14.7196 12.461C18.9516 13.701 19.0006 17.957 19.0006 18H21.0006C21.0006 16.211 20.0446 12.715 16.6046 11.048Z",
    fill: "#2F80ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.3e4255652d9c5149fd37941777f119dc.svg";
export { ForwardRef as ReactComponent };